import { render, staticRenderFns } from "./UnapprovedIDCards.vue?vue&type=template&id=f84ed3fa&"
import script from "./UnapprovedIDCards.vue?vue&type=script&lang=js&"
export * from "./UnapprovedIDCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports